import type {
	MasterDocumentsCreateState,
	SendDocumentsReturnState,
	SendDocumentsSelection,
} from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Modals/SendDocumentsModal/sendDocumentsRoundTrip.types';

/**
 * Narrowing for the router state the "upload document" round trip carries in both directions.
 * Lives beside the modal that owns the round trip so neither Investors nor ProgrammeSettings has
 * to import the other's folder to read it.
 */
const isRecord = (value: unknown): value is Record<string, unknown> =>
	typeof value === 'object' && value !== null;

export const isSendDocumentsSelection = (value: unknown): value is SendDocumentsSelection =>
	isRecord(value) &&
	Array.isArray(value.selectedIds) &&
	value.selectedIds.every((id): id is string => typeof id === 'string');

/** Narrows router state handed back when Master Documents returns control after an upload. */
export const isSendDocumentsReturn = (state: unknown): state is SendDocumentsReturnState =>
	isRecord(state) &&
	state.reopenSendDocuments === true &&
	isSendDocumentsSelection(state.sendDocumentsSelection);

/** Narrows router state carried in by the Send Documents modal's "upload document" round trip. */
export const isMasterDocumentsCreateState = (state: unknown): state is MasterDocumentsCreateState =>
	isRecord(state) &&
	typeof state.returnTo === 'string' &&
	isSendDocumentsSelection(state.sendDocumentsSelection);
